import { connect } from "react-redux";
import React, { useState } from "react";
import Icon from "@mdi/react";
import { mdiClose } from "@mdi/js";
import Style from "./UEModal.scss";

const UEModal = ({ props, title, callback, show, content }) => {
   const [loading, seLoading] = useState();

   return (
      <div id={"ue-modal1-wrapper"} className={"ue-modal1-wrapper"}>
         <div id={"ue-modal1"} className={"ue-modal1 d-flex flex-column h-100 w-100"}>
            <div className={"w-100 p-2"}>
               <div className={"d-flex flex-row justify-content-between align-items-center mb-2"}>
                  <div className={"h3 w-100 text-left ue-modal-title"}>{title}</div>
                  <div className={"ue-btn-icon-sm"} onClick={(e) => show(null)}>
                     <Icon className={"mx-2"} path={mdiClose} size={0.8} color={"var(--theme_primary)"} />
                  </div>
               </div>
               <div className={"d-flex flex-column justify-content-start align-items-center ue-modal1-body "}>
                  {content}
               </div>
            </div>
         </div>
      </div>
   );
};

const mapStateToProps = (state) => {
   return {
      userId: state.MeReducer.id,
      userPrefs: state.MeReducer.prefs,
      username: state.MeReducer.username,
      role: state.MeReducer.role,
      entity: state.MeReducer.entity,
   };
};

const mapDispatchTProps = (dispatch) => {
   return {
      updateUserInfo: (e) => dispatch({ type: "UPDATE_USER_STATUS", data: e }),
   };
};

export default connect(mapStateToProps, mapDispatchTProps)(UEModal);
